(function () {
  'use strict';

  angular.module('sempraWebapp').factory('ErrorPageViewModel', errorPageViewModelFactory);

  /** @ngInject */
  function errorPageViewModelFactory($translate) {
    function ErrorPageViewModel() {
      this.errorMessage = $translate.instant('DEFAULT_ERROR_DESCRIPTION');
      init.call(this);
    }

    ErrorPageViewModel.prototype.destroy = function () {
    };

    return ErrorPageViewModel;

    function init() {
      // var that = this;

    }
  }
})();
